export function checkregistertoken(req) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req)
    };
    console.log('POST Login', requestOptions)
    return fetch('api/checkregistertoken', requestOptions).then((response) => response.json())
}